function listToMap(list) {
  let obj = {}
  list.forEach(item => {
    obj[item.id] = item.name
  })
  return obj
}

const businessMap = {
  公共: 1,
  专业: 2,
  精品课: 3,
  测评: 4,
  咨询: 5,
  倾诉: 6,
  鲸选会员: 7,
  读书会: 8,
  心理FM: 9,
  平台: 10,
  此刻: 11,
  盘古: 12,
  咨询师之家: 13,
  文字咨询: 14,
  文章: 15,
  心探教练: 16,
  故事集: 17
}
const businessList = Object.keys(businessMap)

const eventTypeList = [
  { id: 1, name: '页面访问' },
  { id: 2, name: '交互行为' },
  { id: 3, name: '社交行为' }
]
const eventTypeMap = listToMap(eventTypeList)

const eventAttributeList = ['页面', '对象']
const eventAttributeMap = {
  页面: 1,
  对象: 2
}

export {
  businessList,
  businessMap,
  eventTypeList,
  eventTypeMap,
  eventAttributeList,
  eventAttributeMap
}



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/stat/statFiled.js